import React from 'react';
import { BadgeCheck, Crown, Sparkles, Zap } from 'lucide-react';

const badgeConfig = {
  verified: {
    icon: BadgeCheck,
    color: 'text-blue-500',
    bg: 'bg-blue-500/20',
    label: 'Verificeret'
  },
  premium: {
    icon: Crown,
    color: 'text-amber-500',
    bg: 'bg-amber-500/20',
    label: 'Premium'
  },
  new: {
    icon: Sparkles,
    color: 'text-purple-500',
    bg: 'bg-purple-500/20',
    label: 'Ny bruger'
  },
  active: {
    icon: Zap,
    color: 'text-green-500',
    bg: 'bg-green-500/20',
    label: 'Super aktiv'
  }
};

export const UserBadge = ({ type, label, size = 'sm', showLabel = false }) => {
  const config = badgeConfig[type];
  if (!config) return null;
  
  const Icon = config.icon;
  const sizeClasses = {
    xs: 'w-3 h-3',
    sm: 'w-4 h-4',
    md: 'w-5 h-5',
    lg: 'w-6 h-6'
  };
  
  if (showLabel) {
    return (
      <span className={`inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-xs font-medium ${config.bg} ${config.color}`}>
        <Icon className={sizeClasses[size]} />
        {label || config.label}
      </span>
    );
  }
  
  return (
    <span className={`inline-flex items-center justify-center ${config.color}`} title={label || config.label}>
      <Icon className={sizeClasses[size]} />
    </span>
  );
};

export const UserBadges = ({ badges = [], size = 'sm', showLabels = false, maxVisible = 4 }) => {
  if (!badges || badges.length === 0) return null;
  
  const visibleBadges = badges.slice(0, maxVisible);
  
  if (showLabels) {
    return (
      <div className="flex flex-wrap gap-1">
        {visibleBadges.map((badge, index) => (
          <UserBadge 
            key={index} 
            type={badge.type} 
            label={badge.label} 
            size={size}
            showLabel={true}
          />
        ))}
      </div>
    );
  }
  
  return (
    <div className="flex items-center gap-0.5">
      {visibleBadges.map((badge, index) => (
        <UserBadge 
          key={index} 
          type={badge.type} 
          label={badge.label} 
          size={size}
        />
      ))}
    </div>
  );
};

export default UserBadges;
